import type { AutofillItem } from "./types";

// 英数字を自動生成する（1文字目は必ずアルファベット、以降は英数字）。
// 紛らわしい 'O' と '0' は除外する。
const generateAlphanumeric = (): string => {
  const alphabets = "ABCDEFGHIJKLMNPQRSTUVWXYZ";
  const numbers = "123456789";

  let result = alphabets[Math.floor(Math.random() * alphabets.length)];

  for (let i = 0; i < 2; i++) {
    const chars = alphabets + numbers;
    result += chars[Math.floor(Math.random() * chars.length)];
  }

  return result;
};

export const codeName: AutofillItem[] = [
  {
    keyword: "英数字",
    contents: [() => generateAlphanumeric()],
  },
  {
    keyword: "地名",
    contents: [
      "Acapulco",
      "Alexandria",
      "Alhambra",
      "Amalfi",
      "Amazon",
      "Andorra",
      "Angkor",
      "Ankara",
      "Antarctica",
      "Ararat",
      "Arequipa",
      "Aswan",
      "Aspen",
      "Athens",
      "Auckland",
      "Avalon",
      "Baghdad",
      "Bagan",
      "Bali",
      "Banff",
      "Belize",
      "Barcelona",
      "Bergen",
      "Bhutan",
      "BoraBora",
      "Bordeaux",
      "Borneo",
      "Brussels",
      "Budapest",
      "Brasilia",
      "Cairo",
      "Capri",
      "Casablanca",
      "Catalonia",
      "Cusco",
      "Dakar",
      "Damascus",
      "Edinburgh",
      "Fez",
      "Fiji",
      "Galapagos",
      "Gibraltar",
      "Hanoi",
      "Havana",
      "Himalayas",
      "Istanbul",
      "Jakarta",
      "Kathmandu",
      "Kyoto",
      "Lalibela",
      "Lhasa",
      "MachuPicchu",
      "Madagascar",
      "Marrakech",
      "Maui",
      "Milan",
      "Mombasa",
      "MonteCarlo",
      "Nairobi",
      "Naples",
      "Olympia",
      "Oslo",
      "Patagonia",
      "Phuket",
      "Prague",
      "Quebec",
      "Quito",
      "Rajasthan",
      "Reykjavik",
      "Rome",
      "Samarkand",
      "Santorini",
      "Savannah",
      "Shanghai",
      "Siberia",
      "Sicily",
      "Timbuktu",
      "Tokyo",
      "Transylvania",
      "Ulaanbaatar",
      "Valencia",
      "Venice",
      "Vienna",
      "Xanadu",
      "Yangon",
      "Zanzibar",
      "Cappadocia",
      "Caracas",
      "Cartagena",
      "Chengdu",
      "ChichenItza",
      "Colombo",
      "Corsica",
      "Crete",
      "Delhi",
      "Dubai",
      "Dublin",
      "Durban",
      "Elba",
      "Ellora",
      "Featherdale",
      "Giza",
      "Goa",
      "Granada",
      "Greenland",
      "Guangzhou",
      "Hamburg",
      "Hiroshima",
      "Hobart",
      "Ibiza",
      "InleLake",
      "Jerusalem",
      "Kamchatka",
      "Kilimanjaro",
      "Kingston",
      "Kolkata",
      "Krakow",
      "LaPaz",
      "Lauterbrunnen",
      "Leh",
      "Lijiang",
      "Lima",
      "Lisbon",
      "Liverpool",
      "Ljubljana",
      "Lofoten",
      "Luxor",
      "Lyon",
    ],
  },
  {
    keyword: "デザート",
    contents: [
      "Alfajor",
      "Baklava",
      "BanoffeePie",
      "Blancmange",
      "Brownie",
      "Cannoli",
      "Charlotte",
      "Cheesecake",
      "Churros",
      "Clafoutis",
      "Cobbler",
      "CremeBrulee",
      "Cupcake",
      "Dacquoise",
      "DobosTorte",
      "Eclair",
      "Financier",
      "Flan",
      "Fondant",
      "FruitTart",
      "Galette",
      "Gelato",
      "Genoise",
      "Halva",
      "Honeycake",
      "Jalebi",
      "Kanafeh",
      "KeyLimePie",
      "Kulfi",
      "Lamington",
      "LinzerTorte",
      "Macaron",
      "Madeleine",
      "Meringue",
      "MilleFeuille",
      "Mochi",
      "Napoleon",
      "OperaCake",
      "PannaCotta",
      "Pavlova",
      "PecanPie",
      "PetitFour",
      "PoundCake",
      "Profiterole",
      "Pudding",
      "PumpkinPie",
      "RedVelvetCake",
      "RumBaba",
      "SacherTorte",
      "Semifreddo",
      "Shortcake",
      "Souffle",
      "Spumoni",
      "StickyToffeePudding",
      "Strudel",
      "Tiramisu",
      "Torte",
      "Trifle",
      "Truffle",
      "UpsideDownCake",
      "Vacherin",
      "WhoopiePie",
      "Zabaglione",
      "Zeppole",
    ],
  },
  {
    keyword: "天体",
    contents: [
      "Andromeda",
      "Antares",
      "Aquarius",
      "Aquila",
      "Aries",
      "Aurora",
      "Betelgeuse",
      "Callisto",
      "CanisMajor",
      "Capricorn",
      "Cassiopeia",
      "Centauri",
      "Cepheus",
      "Ceres",
      "Charon",
      "Comet",
      "Corona",
      "Cygnus",
      "Deimos",
      "Draco",
      "Electra",
      "Eridanus",
      "Europa",
      "Fomalhaut",
      "Galatea",
      "Gemini",
      "Halley",
      "Helix",
      "Hercules",
      "Hyperion",
      "Io",
      "Jupiter",
      "Kale",
      "Leo",
      "Libra",
      "Lyra",
      "Maia",
      "Mars",
      "Mercury",
      "Meteor",
      "MilkyWay",
      "Miranda",
      "Nebula",
      "Neptune",
      "Nova",
      "Orion",
      "Pegasus",
      "Perseus",
      "Phobos",
      "Pisces",
      "Pleiades",
      "Pluto",
      "Pollux",
      "Proxima",
      "Rigel",
      "Saturn",
      "Scorpius",
      "Sirius",
      "Sol",
      "Sputnik",
      "StarDust",
      "Taurus",
      "Titania",
      "Triton",
      "Uranus",
      "Vega",
      "Venus",
      "Vesta",
      "Virgo",
      "Vulcan",
    ],
  },
  {
    keyword: "神話",
    contents: [
      "Achilles",
      "Adonis",
      "Aeneas",
      "Andromeda",
      "Apollo",
      "Arachne",
      "Ares",
      "Artemis",
      "Athena",
      "Atlas",
      "Baldur",
      "Bellerophon",
      "Bragi",
      "Calypso",
      "Cerberus",
      "Cupid",
      "Daedalus",
      "Daphne",
      "Demeter",
      "Diana",
      "Dionysus",
      "Echo",
      "Eos",
      "Eris",
      "Eros",
      "Freyja",
      "Freyr",
      "Gaia",
      "Galatea",
      "Ganymede",
      "Hades",
      "Hecate",
      "Helios",
      "Hera",
      "Hercules",
      "Hermes",
      "Hestia",
      "Hippolyta",
      "Hyperion",
      "Icarus",
      "Iris",
      "Isis",
      "Janus",
      "Juno",
      "Jupiter",
      "Krishna",
      "Loki",
      "Maia",
      "Mars",
      "Medusa",
      "Mercury",
      "Minerva",
      "Morpheus",
      "Narcissus",
      "Nemesis",
      "Neptune",
      "Nike",
      "Odin",
      "Orion",
      "Osiris",
      "Pan",
      "Pandora",
      "Persephone",
      "Phoebe",
      "Pluto",
      "Poseidon",
      "Prometheus",
      "Rhea",
      "Selene",
      "Thor",
      "Venus",
      "Vesta",
      "Vulcan",
      "Zeus",
    ],
  },
  {
    keyword: "動物",
    contents: [
      "Albatross",
      "Antelope",
      "Armadillo",
      "BarnOwl",
      "Bison",
      "BlackPanther",
      "Cheetah",
      "Chimpanzee",
      "Cobra",
      "Condor",
      "Dolphin",
      "Dragonfly",
      "Eagle",
      "Elephant",
      "Falcon",
      "Flamingo",
      "Fox",
      "Gazelle",
      "Giraffe",
      "Hawk",
      "Hippopotamus",
      "Ibis",
      "Jaguar",
      "Kangaroo",
      "Kingfisher",
      "Koala",
      "Leopard",
      "Lynx",
      "Macaw",
      "Manatee",
      "Narwhal",
      "Octopus",
      "Orangutan",
      "Osprey",
      "Otter",
      "Panda",
      "Peacock",
      "Pelican",
      "Penguin",
      "Phoenix",
      "PolarBear",
      "Porcupine",
      "Quetzal",
      "Raccoon",
      "RedPanda",
      "Rhinoceros",
      "Salamander",
      "SeaTurtle",
      "SnowLeopard",
      "Sparrow",
      "Sphinx",
      "Stingray",
      "Swan",
      "Tiger",
      "Toucan",
      "Umbrellabird",
      "Vulture",
      "Walrus",
      "Warthog",
      "Wildebeest",
      "Wolf",
      "Wombat",
      "Woodpecker",
      "Yak",
      "Zebra",
      "Zeppelin",
      "Zorilla",
    ],
  },
  {
    keyword: "色",
    contents: [
      "Auburn",
      "Azure",
      "Beige",
      "Bisque",
      "Blush",
      "Bronze",
      "Burgundy",
      "Carmine",
      "Cerulean",
      "Charcoal",
      "Chartreuse",
      "Chestnut",
      "Citrine",
      "Clay",
      "Cobalt",
      "Copper",
      "Coral",
      "Crimson",
      "Cyan",
      "Denim",
      "Emerald",
      "Fuchsia",
      "Garnet",
      "Gold",
      "Harlequin",
      "Indigo",
      "Ivory",
      "Jade",
      "Jet",
      "Khaki",
      "Lavender",
      "Lemon",
      "Lilac",
      "Lime",
      "Magenta",
      "Mahogany",
      "Maroon",
      "Mauve",
      "Moss",
      "Mustard",
      "Navy",
      "Ochre",
      "Olive",
      "Onyx",
      "Opal",
      "Peach",
      "Pearl",
      "Periwinkle",
      "Plum",
      "Puce",
      "Raspberry",
      "Ruby",
      "Saffron",
      "Sage",
      "Salmon",
      "Sapphire",
      "Scarlet",
      "Sienna",
      "Silver",
      "Taupe",
      "Teal",
      "Thistle",
      "Turquoise",
      "Umber",
      "Vermilion",
      "Violet",
      "Viridian",
      "Wheat",
      "Wisteria",
      "Zinnia",
    ],
  },
  {
    keyword: "宝石",
    contents: [
      "Agate",
      "Alexandrite",
      "Amber",
      "Amethyst",
      "Apatite",
      "Aquamarine",
      "Aventurine",
      "Azurite",
      "Beryl",
      "Bloodstone",
      "Carnelian",
      "Chalcedony",
      "Charoite",
      "Chrysocolla",
      "Chrysoprase",
      "Citrine",
      "Coral",
      "Diamond",
      "Diopside",
      "Emerald",
      "Fluorite",
      "Garnet",
      "Goshenite",
      "Heliodor",
      "Hematite",
      "Iolite",
      "Jade",
      "Jasper",
      "Kunzite",
      "Kyanite",
      "Labradorite",
      "LapisLazuli",
      "Larimar",
      "Malachite",
      "Moonstone",
      "Morganite",
      "Onyx",
      "Opal",
      "Peridot",
      "Pyrite",
      "Quartz",
      "Rhodochrosite",
      "Rhodonite",
      "Ruby",
      "Sapphire",
      "Sardonyx",
      "Serpentine",
      "Spinel",
      "Sunstone",
      "Tanzanite",
      "Topaz",
      "Tourmaline",
      "Turquoise",
      "Unakite",
      "Variscite",
      "Zircon",
      "Amazonite",
      "Andalusite",
      "Benitoite",
      "Chrysoberyl",
      "Danburite",
      "Epidote",
      "Garnierite",
      "Howlite",
      "Jadeite",
      "Jet",
      "Kornerupine",
      "Lazulite",
    ],
  },
];
